/**
 * App-wide TanStack Form hook with bound field components.
 * Use `useAppForm` to create forms and `withForm` to build typed section
 * components. Inline errors come from <FieldErrorsProvider> (see ./fields/field-errors).
 * Aliases: useAppForm, app form hook, tanstack form factory, withForm.
 */
import { createFormHook } from "@tanstack/react-form";

import { CheckboxField } from "./fields/checkbox-field";
import { fieldContext, formContext } from "./fields/field-context";
import { ImageField } from "./fields/image-field";
import { NumberField } from "./fields/number-field";
import { RichTextField } from "./fields/rich-text-field";
import { SelectField } from "./fields/select-field";
import { TextField } from "./fields/text-field";
import { TextareaField } from "./fields/textarea-field";

export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    TextField,
    NumberField,
    TextareaField,
    SelectField,
    CheckboxField,
    ImageField,
    RichTextField,
  },
  formComponents: {},
  fieldContext,
  formContext,
});
